
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M21.36 12.172a5 5 0 1 1 .356-9.994 5 5 0 0 1-.356 9.994ZM21.794 29.054a7 7 0 1 1 .5-13.992 7 7 0 0 1-.5 13.992ZM7.996 18.664A6 6 0 1 1 8.424 6.67a6 6 0 0 1-.428 11.993Z","clip-rule":"evenodd"}})])
          )
        }
      }
    